"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatFuelType = void 0;
const formatKeyVal_1 = require("./formatKeyVal");
const formatFuelType = (fuelType) => ({
    ...(0, formatKeyVal_1.formatKeyVal)(fuelType),
    tariffClassification: fuelType.tariffClassification,
});
exports.formatFuelType = formatFuelType;
